const aaa = [
	{
		path: "versionAdd",
		component: () => import("@/views/version/versionAdd.vue"),
		meta:{title:'版本更新'},
	},
]
export default aaa;